"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var filterOptions = function filterOptions(options, searchValue) {
  return options.filter(function (_ref) {
    var label = _ref.label;
    return label.toLowerCase().includes(searchValue.toLowerCase());
  });
};

var _default = filterOptions;
exports.default = _default;